import { Link } from 'react-router-dom';
import { SERVICES, PAGES } from '../data';
import logo from '../logo.svg';

export default function Footer() {
  const pagePath = (p) => (p === 'Home' ? '/' : `/${p.toLowerCase()}`);

  return (
    <footer style={{ background:'var(--dark)', color:'#c0b8b0', padding:'5rem clamp(1.2rem,4vw,3rem) 2rem' }}>
      <div className="sw">
        <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1fr 1fr', gap:'3rem', marginBottom:'3rem' }}>

          {/* Brand */}
          <div>
            <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'1.2rem' }}>
              <img src={logo} alt="ELBOT Logo"  style={{ width: '170px' }}  />
            </div>
            <p style={{ fontSize:'.88rem', lineHeight:1.8, maxWidth:'270px', color:'#8a8278', marginBottom:'1.5rem' }}>
              Automation & Controls Specialists delivering bespoke industrial solutions that lower costs and sharpen your competitive edge.
            </p>
            <div style={{ display:'flex', gap:'.7rem', flexWrap:'wrap' }}>
              {['LinkedIn'].map(s => (
                <a key={s} href="https://www.linkedin.com/company/elbot-automation" target="_blank" rel="noopener noreferrer" className="footer-link"
                  style={{ border:'1px solid var(--white-10)', padding:'5px 11px', borderRadius:'4px', color:'var(--footer-text)', transition:'all .25s' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor='var(--o)'; e.currentTarget.style.color='var(--o)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor='var(--white-10)'; e.currentTarget.style.color='var(--footer-text)'; }}
                >{s}</a>
              ))}
            </div>
          </div>

          {/* Pages */}
          <div>
            <div style={{ fontFamily:'var(--fH)', fontSize:'.9rem', letterSpacing:'2px', color:'var(--o)', marginBottom:'1.2rem' }}>PAGES</div>
            {PAGES.map(p => (
              <div key={p} style={{ marginBottom:'.6rem' }}>
                <Link to={pagePath(p)} className="footer-link" style={{ color:'#8a8278' }}>{p}</Link>
              </div>
            ))}
          </div>

          {/* Services */}
          <div>
            <div style={{ fontFamily:'var(--fH)', fontSize:'.9rem', letterSpacing:'2px', color:'var(--o)', marginBottom:'1.2rem' }}>SERVICES</div>
            {SERVICES.map(s => (
              <div key={s.title} style={{ marginBottom:'.55rem' }}>
                <Link to="/services" className="footer-link" style={{ color:'#8a8278', fontSize:'.8rem' }}>{s.title}</Link>
              </div>
            ))}
          </div>

          {/* Contact */}
          <div>
            <div style={{ fontFamily:'var(--fH)', fontSize:'.9rem', letterSpacing:'2px', color:'var(--o)', marginBottom:'1.2rem' }}>CONTACT</div>
            {[
             { i:'📍', v:' F-68 Sector-3 DSIIDC', href:'https://maps.app.goo.gl/LqDbPAUeHeHmvhd36' },
              { i:' ', v:'Bawana Industrial Area', href:'https://maps.app.goo.gl/LqDbPAUeHeHmvhd36' },
              { i:' ', v:'Delhi - 110039', href:'https://maps.app.goo.gl/LqDbPAUeHeHmvhd36' },
              { i:'📧', v:'info@elbotautomation.com', href:'mailto:info@elbotautomation.com' },
               { i:'📞', v:'011-4475382' },
              { i:'📞', v:'+919582226718' },
            ].map(c => (
              <div key={c.v} style={{ display:'flex', gap:'8px', marginBottom:'.9rem' }}>
                <span style={{ fontSize:'.85rem' }}>{c.i}</span>
                {c.href ? (
                  <a href={c.href} target="_blank" rel="noopener noreferrer" style={{ color:'#8a8278', fontSize:'.8rem', fontFamily:'var(--fM)', textDecoration:'none', transition:'color .25s' }}
                    onMouseEnter={e => e.currentTarget.style.color='var(--o)'}
                    onMouseLeave={e => e.currentTarget.style.color='#8a8278'}
                  >{c.v}</a>
                ) : (
                  <span style={{ color:'#8a8278', fontSize:'.8rem', fontFamily:'var(--fM)' }}>{c.v}</span>
                )}
              </div>
            ))}
          </div>
        </div>

        <div style={{ borderTop:'1px solid var(--white-7)', paddingTop:'1.5rem', display:'flex', justifyContent:'space-between' }}>
          <span style={{ color:'var(--footer-text)', fontFamily:'var(--fM)', fontSize:'.75rem' }}>© 2026 Elbot Automation Pvt. Ltd. All rights reserved.</span>
          <span style={{ color:'var(--footer-text)', fontFamily:'var(--fM)', fontSize:'.75rem' }}>Engineered with precision ⚙️</span>
        </div>
      </div>
    </footer>
  );
}
